import React from "react";
import { Table, Switch, message } from "antd";
import { useUserModel } from "../userModel";
import { ColumnsType } from "antd/es/table";
import { IMdUserDetail } from "../UserTypes";
import { EditModeType } from "@src/types/FmsTypes";
import { YhBut } from "@src/components/YhButton";
import { IMdRoleDetail } from "../../role/RoleTypes";
import { IMdStoreDetail } from "@src/views/authPortal/base/store/StoreTypes";
import moment from "moment";
import { userService } from "../UserService";
import { YhAuth } from "@src/components/auth/YhAuth";
import { globalPrompt } from "@src/components/YhMessage";
import { momentFormats } from "@src/utils/utils";


export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
        drawerVisible,
        setDrawerVisible,
        setPwdVisible,
        setSelectedRow,
        setEditType
    } = useUserModel();

    const onDetail = (type: EditModeType, data: IMdUserDetail) => {
        console.log(data)
        setDrawerVisible(true)
        setSelectedRow(data)
        setEditType(type)
    }

    const changePwd = (data: IMdUserDetail) => {
        drawerVisible && setDrawerVisible(false)
        setPwdVisible(true)
        setSelectedRow(data)
    }

    const disableUser = async (record: IMdUserDetail, check: number) => {
        // console.log(record);
        // console.log(check);
        // debugger
        // const { retData } = await userService.disableUser(record?.code ?? "", check);
        const updateRet = await userService.updateLocal({
            ...record,
            createTime: moment(record?.createTime).format("YYYY-MM-DD HH:mm:ss"),
            shops: record?.shops?.map(item => item.code),
            roles: record?.roles?.map(item => item.code),
            enable: check ? 0 : 1,
            status: check ? 1 : 0
        });
        if (updateRet.success) {
            await globalPrompt("message", { type: "success", text: '修改成功!' });
            setDrawerVisible(false)
            loadData()
        } else {
            await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
        }
        // if (retData) {
        //     loadData();
        //     message.success(check ? "禁用成功" : "启用成功");
        // }
    }
    const columns: ColumnsType<IMdUserDetail> = [
        {
            align: 'center',
            title: '序号',
            width: 60,
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            title: '员工工号',
            width: 150,
            dataIndex: 'staffId',
        },
        {
            align: "center",
            title: '账户',
            width: 150,
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '用户姓名',
            width: 150,
            dataIndex: 'name',
        },
        {
            align: "center",
            title: '用户类型',
            width: 150,
            dataIndex: 'userTypeName',
        },
        {
            align: "center",
            title: '联系电话',
            width: 150,
            dataIndex: 'phoneNumber',
        },
        {
            align: "center",
            title: '所属机构',
            width: 120,
            dataIndex: 'orgName',
        },
        {
            align: "center",
            title: '所属门店',
            width: 150,
            dataIndex: 'shops',
            render: (value, record, index) => {
                return value.map((item: IMdStoreDetail) => <span className="my-tag">{item.name}</span>)
            }
        },
        {
            align: "center",
            title: '所属角色',
            width: 150,
            dataIndex: 'roles',
            render: (value, record, index) => {
                return value.map((item: IMdRoleDetail) => <span className="my-tag _orange">{item.name}</span>)
            }
        },
        {
            align: "center",
            title: '创建人',
            width: 120,
            dataIndex: 'createUser',
        },
        {
            align: "center",
            title: '创建时间',
            width: 200,
            dataIndex: 'createTime',
            render: (value) => momentFormats(value)
        },
        {
            align: "center",
            title: '操作',
            width: 120,
            dataIndex: 'enable',
            fixed: "right",
            render: (value, record, index) => {
                return (
                    <>
                        <YhAuth resCode="portal2.au.user.vw">
                            <YhBut
                                typeName="icon-chakan"
                                text="查看"
                                style={{ color: "#1296DB", fontSize: "18px" }}
                                click={() => onDetail('look', record)}
                            />
                        </YhAuth>
                        <YhAuth resCode="portal2.au.user.ed">
                            <YhBut
                                typeName="icon-bianji1"
                                text="编辑"
                                style={{ color: "#028E19", fontSize: "18px" }}
                                click={() => onDetail('edit', record)}
                            />
                        </YhAuth>
                        <YhAuth resCode="portal2.au.user.reset">
                            <YhBut
                                typeName="icon-zhongzhi-"
                                text="重置密码"
                                style={{ color: "rgb(50,50,50)", fontSize: "18px" }}
                                click={() => changePwd(record)}
                            />
                        </YhAuth>
                    </>
                )
            }
        },
        {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            fixed: "right",
            align: "center",
            render: (text, record) => (
                <YhAuth resCode="portal2.au.user.able">
                    <Switch
                        checkedChildren={"开启"}
                        unCheckedChildren={"关闭"}
                        checked={+(record.status ?? 0) ? false : true}
                        onChange={(checked: boolean, e: MouseEvent) => {
                            e.stopPropagation();
                            disableUser(record, checked ? 0 : 1);
                        }}
                    />
                </YhAuth>
            ),
        }
        // {
        //     align: "center",
        //     title: '状态',
        //     dataIndex: 'status',
        //     width: 120,
        //     render: (v) => v === 0 ? "启用" : "禁用"
        // },
    ];


    return (
        <Table
            style={{ cursor: "pointer" }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}


